// extracted by mini-css-extract-plugin
export default {"pageContainer":"GPTInterface_pageContainer__fyoSt","button":"GPTInterface_button__hn1Z8"};